import React, { memo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  dark?: boolean;
}

const LifeBeltIcon = ({ dark = false, ...props }: Props) => {
  const { palette }: Theme = useTheme();
  const color = dark ? palette.secondary.lightest : palette.primary.main;
  return (
    <SvgIcon width={20} height={20} {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 16C11.2958 16 12.4957 15.5892 13.4765 14.8907L16.3287 17.7429C14.6049 19.1536 12.4013 20 10 20C7.59873 20 5.39515 19.1536 3.67128 17.743L6.52348 14.8908C7.50429 15.5892 8.70417 16 10 16ZM13.4765 5.10926C12.4957 4.41079 11.2958 4 10 4C8.70417 4 7.50429 4.41079 6.52347 5.10925L3.67127 2.25705C5.39514 0.846364 7.59873 0 10 0C12.4013 0 14.6049 0.846369 16.3287 2.25706L13.4765 5.10926ZM14.8908 6.52348C15.5892 7.50429 16 8.70417 16 10C16 11.2958 15.5892 12.4957 14.8907 13.4765L17.7429 16.3287C19.1536 14.6049 20 12.4013 20 10C20 7.59874 19.1536 5.39515 17.743 3.67128L14.8908 6.52348ZM5.10926 13.4765C4.41079 12.4957 4 11.2958 4 10C4 8.70417 4.41079 7.50428 5.10925 6.52346L2.25706 3.67126C0.846366 5.39514 0 7.59873 0 10C0 12.4013 0.846369 14.6049 2.25706 16.3287L5.10926 13.4765Z"
        fill={color}
      />
    </SvgIcon>
  );
};

export default memo(LifeBeltIcon);
